import React, {useCallback, useState, useEffect} from 'react';
import { message } from 'antd';
import {useParams, useNavigate} from 'react-router-dom'

import BaseEdit from "./base.edit"
import ContentEdit from './content.edit'
import Api from '../../api'
import {emptyValidate} from "../../util/validate";

export default function CourseSingle() {
    const navigate = useNavigate();
    const params = useParams();
    const [baseInfo, setBaseInfo] = useState({})
    const [courseInfo, setCourseInfo] = useState({})
    const [lecturerList, setlecturerList] = useState([])

    const [inited, setInited] = useState(false)

    useEffect(()=>{
        if (params.id) {
            Api.getCourseInfo(params.id).then(resp=>{
                setBaseInfo(resp.info.course)
                setlecturerList(resp.info.lecturerList)
                setCourseInfo(resp.info.courseInfoList[0])
                setInited(true)
            })
        } else {
            setBaseInfo({});
            setlecturerList([])
            setCourseInfo({})
            setInited(true)
        }
    },[params.id])


    const onUpdate = useCallback((data)=>{
        setBaseInfo(Object.assign({},baseInfo,data))
    })
    const onSave = useCallback((data)=>{
        let validateResult = emptyValidate(baseInfo.courseName, '请填写课程名称')
            || emptyValidate(baseInfo.coverImg, '请上传课程封面')
            || emptyValidate(data.filePaths.length, '请上传课程内容');

        if (validateResult) {
            return;
        }

        Api.createUpdateCourse({
            ...baseInfo,
            ...data,
            infoTypeCode: data.typeCode,
            typeCode: 2
        }).then(resp=>{
            if (resp.resultCode === 1) {
                message.success(resp.resultMessage)
                if (params.id) {
                    navigate(-1)
                } else {
                    navigate('/course/list')
                }
            }
        })
    })

    const onCancel = useCallback((data)=>{
        if (params.id) {
            navigate(-1)
        } else {
            navigate('/course/list')
        }
    })


    return <>
        {inited && <BaseEdit onUpdate={onUpdate} data={baseInfo} lecturerList={lecturerList}/>}
        {inited && <ContentEdit onSave={onSave} onCancel={onCancel} data={courseInfo}/>}
    </>
}




